import React from 'react';
import { useMsal, useAccount } from '@azure/msal-react';

function Dashboard({ onNavigate }) {
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    const userName = account?.idTokenClaims?.preferred_username
        || account?.idTokenClaims?.email
        || account?.username
        || 'there';

    const firstName = userName.split('.')[0].charAt(0).toUpperCase() + userName.split('.')[0].slice(1);

    const capabilities = [
        {
            id: 'assistant',
            icon: '💬',
            title: 'AI Assistant',
            description: 'General-purpose AI for drafting, analysis, research, and document Q&A. Upload files and ask questions.',
            status: 'live',
            action: () => onNavigate('assistant')
        },
        {
            id: 'bots',
            icon: '🤖',
            title: 'Knowledge Bots',
            description: 'AI grounded in approved Hale Partnership documents and policies. Accurate, auditable answers.',
            status: 'live',
            action: () => onNavigate('bots')
        }
    ];

    return (
        <div style={{ padding: '2rem', maxWidth: '960px', margin: '0 auto' }}>

            {/* Welcome */}
            <div style={{ marginBottom: '2rem' }}>
                <h1 style={{ fontSize: '1.6rem', fontWeight: 700, color: '#1a4d2e', marginBottom: '0.25rem' }}>
                    Good {getTimeOfDay()}, {firstName}
                </h1>
                <p style={{ color: '#6c757d', fontSize: '0.95rem' }}>
                    Welcome to the Hale Partnership AI Workspace — governed, secured, and audited.
                </p>
            </div>

            {/* Capabilities */}
            <div style={{ marginBottom: '1rem' }}>
                <h2 style={{ fontSize: '1rem', fontWeight: 600, color: '#1a4d2e', marginBottom: '1rem' }}>
                    Platform Capabilities
                </h2>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem' }}>
                    {capabilities.map(cap => (
                        <div
                            key={cap.id}
                            onClick={cap.action || undefined}
                            style={{
                                background: 'white',
                                borderRadius: '12px',
                                padding: '1.5rem',
                                border: '1.5px solid',
                                borderColor: cap.status === 'live' ? '#e0e4e8' : '#f0f2f5',
                                cursor: cap.action ? 'pointer' : 'default',
                                opacity: cap.status === 'soon' ? 0.7 : 1,
                                transition: 'all 0.15s',
                                position: 'relative'
                            }}
                            onMouseEnter={e => { if (cap.action) e.currentTarget.style.borderColor = '#4a9e6d'; }}
                            onMouseLeave={e => { if (cap.action) e.currentTarget.style.borderColor = cap.status === 'live' ? '#e0e4e8' : '#f0f2f5'; }}
                        >
                            {cap.status === 'soon' && (
                                <div style={{
                                    position: 'absolute', top: '0.75rem', right: '0.75rem',
                                    background: '#f0f2f5', color: '#6c757d',
                                    fontSize: '0.65rem', fontWeight: 600,
                                    padding: '0.15rem 0.5rem', borderRadius: '10px',
                                    textTransform: 'uppercase', letterSpacing: '0.05em'
                                }}>
                                    Coming Soon
                                </div>
                            )}
                            {cap.status === 'live' && (
                                <div style={{
                                    position: 'absolute', top: '0.75rem', right: '0.75rem',
                                    background: '#d4edda', color: '#155724',
                                    fontSize: '0.65rem', fontWeight: 600,
                                    padding: '0.15rem 0.5rem', borderRadius: '10px',
                                    textTransform: 'uppercase', letterSpacing: '0.05em'
                                }}>
                                    Live
                                </div>
                            )}
                            <div style={{ fontSize: '2rem', marginBottom: '0.75rem' }}>{cap.icon}</div>
                            <div style={{ fontWeight: 600, color: '#1a4d2e', marginBottom: '0.4rem', fontSize: '0.95rem' }}>
                                {cap.title}
                            </div>
                            <div style={{ fontSize: '0.82rem', color: '#6c757d', lineHeight: 1.5 }}>
                                {cap.description}
                            </div>
                            {cap.action && (
                                <div style={{ marginTop: '1rem' }}>
                                    <span style={{ fontSize: '0.8rem', color: '#4a9e6d', fontWeight: 500 }}>
                                        Open →
                                    </span>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>

            {/* Governance footer */}
            <div style={{
                marginTop: '2rem', padding: '1rem 1.25rem',
                background: 'white', borderRadius: '10px',
                border: '1px solid #e0e4e8',
                display: 'flex', alignItems: 'center', gap: '0.75rem'
            }}>
                <span style={{ fontSize: '1.25rem' }}>🔒</span>
                <div>
                    <div style={{ fontSize: '0.82rem', fontWeight: 600, color: '#1a4d2e' }}>
                        Enterprise Governed AI
                    </div>
                    <div style={{ fontSize: '0.78rem', color: '#6c757d' }}>
                        All interactions are logged, audited, and secured by HP Managing Agency.
                    </div>
                </div>
            </div>
        </div>
    );
}

function getTimeOfDay() {
    const hour = new Date().getHours();
    if (hour < 12) return 'morning';
    if (hour < 17) return 'afternoon';
    return 'evening';
}

export default Dashboard;